module.exports = __webpack_public_path__ + "img/tiktok.413ba3f9.png";